import React from 'react'
import {
  BaseForm,
  Input,
  CheckboxGroup,
  Checkbox,
  VALIDATION_TYPES,
} from '../../../../components/Form'

import { getMessage } from '../../../../lib/translator'

const METHOD_OPTIONS = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'].map((m) => ({
  value: m,
  text: m,
}))

export default class EndpointForm extends BaseForm {
  render() {
    const { Form } = this.components
    const { SubmitButton, CancelButton } = this.buttons
    return (
      <Form className="endpoint-form">
        <Input
          type="text"
          label={getMessage('endpoint.url')}
          placeholder={getMessage('endpoint.url.placeholder')}
          name="url"
          required
          {...this.generateStateMappers({
            stateKeys: ['url'],
            validationType: VALIDATION_TYPES.ONSUBMIT,
            loseEmphasisOnFill: true,
          })}
        />
        <CheckboxGroup
          name="allowedMethods"
          label={getMessage('endpoint.methods')}
          options={METHOD_OPTIONS}
          {...this.generateStateMappers({
            stateKeys: ['allowedMethods'],
            loseEmphasisOnFill: true,
          })}
        />
        <Checkbox
          name="allowEnterpriseAccess"
          inlineLabel={getMessage('endpoint.enterpriseAccess')}
          {...this.generateStateMappers({
            stateKeys: ['allowEnterpriseAccess'],
            loseEmphasisOnFill: true,
          })}
        />
        <Checkbox
          name="allowAuthorizationOverride"
          inlineLabel={getMessage('endpoint.authOverride')}
          {...this.generateStateMappers({
            stateKeys: ['allowAuthorizationOverride'],
            loseEmphasisOnFill: true,
          })}
        />
        <div className="form-actions">
          <CancelButton>{getMessage('endpoint.cancel')}</CancelButton>
          <SubmitButton>{getMessage('endpoint.submit')}</SubmitButton>
        </div>
      </Form>
    )
  }
}
